<template>
<div class="table-wrapper">
  <el-table ref="selectionTable" :data="dataset" class="table-el-table" @selection-change="selectionChange" @sort-change="sortChange">
    <template v-for="col in config.columns">
      <el-table-column
        v-if="col.type === 'Checkbox'"
        :key="col.colId"
        type="selection"
        width="55"
      />
      <el-table-column
        v-else
        :key="col.colId"
        :prop="col.colId"
        :label="col.header"
        :width="col.width"
        :sortable="col.sortable"
      >
        <template slot="header">
          <span>{{ col.header }}</span>
          <el-tooltip v-if="col.tooltip" :content="col.tooltip" placement="top">
            <i class="el-icon-question table-header-space" />
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <component
            :is="col.component"
            v-if="col.component"
            :row="scope.row"
            :col="col"
            :data="scope.row[col.colId]"
            @click="clickHandler($event, scope.row, col)"
          />
          <MyCloumn
            v-else-if="col.type && col.type !== 'Text'"
            :row="scope.row"
            :col="col"
            @click="clickHandler($event, scope.row, col)"
          />
          <span v-else>{{ scope.row[col.colId] }}</span>
        </template>
      </el-table-column>
    </template>
  </el-table>
  <slot name="footer">
    <Footer v-show="!config.isHideFooter"
      :config="config"
      :total="total"
      :is-total="isTotal"
      :cur-page="curPage"
      :all-check="allCheckFlag"
      :checkedRows="checkedRows"
      :showCheckedNum="showCheckedNum"
      @checkAll="checkAllChange"
      @btnClick="bottomBtnClick"
      @pageChange="pageChange"
    />
  </slot>
</div>
</template>

<script>
import Footer from './Footer.vue';
import MyCloumn from './column/Column.vue';

export default {
  name: 'Table',
  components: {
    Footer,
    MyCloumn,
  },
  props: ['config', 'dataset', 'total', 'curPage', 'isTotal', 'showCheckedNum'],
  data() {
    return {
      checkedRows: [],
    };
  },
  computed: {
    allCheckFlag() {
      return this.dataset.length !== 0 && this.checkedRows.length === this.dataset.length;
    },
  },
  methods: {
    checkAllChange(checked) {
      if (checked === false) {
        this.$refs.selectionTable.clearSelection();
      } else {
        this.$refs.selectionTable.toggleAllSelection();
      }
    },
    bottomBtnClick(event) {
      this.$emit('bottomClick', event);
    },
    pageChange(page) {
      this.$emit('pageChange', page);
    },
    clickHandler(event, row, col) {
      // 向外发送事件
      this.$emit('columnClick', { originEvent: event, type: col.type, colId: col.colId, rowData: row });
    },
    selectionChange(rows) {
      this.checkedRows = rows;
      this.$emit('selectionChange', rows);
    },
    sortChange(event) {
      this.$emit('sortChange', event);
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  width: 100%;
}
.table-el-table {
  width: 100%;
}
.table-header-space {
  margin-left: 3px;
}
</style>
